// extracted by mini-css-extract-plugin
export default {"wrapper":"AddUser_wrapper__k4OYY","header":"AddUser_header__Wdxav","title":"AddUser_title__Z4MRV","contain":"AddUser_contain__LaMdj","button-back":"AddUser_button-back__lGLL6"};